document.documentElement.classList.remove('no-js');

function pkMoney(cents, currency) {
  const value = Number(cents || 0) / 100;
  const code = currency || 'MVR';
  try {
    const amount = new Intl.NumberFormat(undefined, {
      minimumFractionDigits: value % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    }).format(value);
    return `${code} ${amount}`;
  } catch (e) {
    return `${code} ${value % 1 === 0 ? value.toFixed(0) : value.toFixed(2)}`;
  }
}

function pkEscape(value) {
  return String(value ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
}

function pkClosePopovers(except) {
  document.querySelectorAll('[data-pk-popover].is-open').forEach((popover) => {
    if (popover !== except) {
      popover.classList.remove('is-open');
      popover.querySelectorAll('[data-pk-popover-trigger]').forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
    }
  });
}

function initPopovers() {
  document.querySelectorAll('[data-pk-popover]').forEach((popover) => {
    popover.querySelectorAll('[data-pk-popover-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        const willOpen = !popover.classList.contains('is-open');
        pkClosePopovers(popover);
        popover.classList.toggle('is-open', willOpen);
        popover.querySelectorAll('[data-pk-popover-trigger]').forEach((item) => item.setAttribute('aria-expanded', willOpen ? 'true' : 'false'));
      });
    });
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-pk-popover]')) pkClosePopovers();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') pkClosePopovers();
  });
}

function renderMiniCart(cart, popover) {
  if (!popover || !cart) return;

  const count = Number(cart.item_count || 0);
  document.querySelectorAll('[data-cart-count]').forEach((badge) => {
    badge.textContent = count;
    badge.classList.toggle('is-hidden', count === 0);
  });

  const itemLabel = popover.querySelector('[data-cart-items-label]');
  if (itemLabel) itemLabel.textContent = `${count} ${count === 1 ? 'item' : 'items'}`;

  const subtotal = popover.querySelector('[data-cart-subtotal]');
  if (subtotal) subtotal.textContent = pkMoney(cart.total_price, cart.currency);

  const checkout = popover.querySelector('[data-cart-checkout]');
  if (checkout) checkout.disabled = count === 0;

  const body = popover.querySelector('[data-cart-panel-body]');
  if (!body) return;

  if (!count) {
    const emptyLabel = popover.dataset.cartEmptyLabel || 'Your cart is empty.';
    body.innerHTML = `<div class="pk-cart-empty">${pkEscape(emptyLabel)}</div>`;
    return;
  }

  const previewLimit = Math.max(1, Number(popover.dataset.cartPreviewLimit || 4));
  const visible = (cart.items || []).slice(0, previewLimit);
  const rows = visible.map((item) => {
    const image = item.image
      ? `<a href="${pkEscape(item.url)}" class="pk-cart-mini-item__image"><img src="${pkEscape(item.image)}" alt="${pkEscape(item.product_title)}" loading="lazy"></a>`
      : '<span class="pk-cart-mini-item__image"></span>';
    return `<div class="pk-cart-mini-item">
      ${image}
      <div class="pk-cart-mini-item__info">
        <a href="${pkEscape(item.url)}" class="pk-cart-mini-item__title">${pkEscape(item.product_title)}</a>
        <span>Qty ${Number(item.quantity || 0)}</span>
        <button type="button" class="pk-cart-mini-item__remove" data-cart-remove data-cart-key="${pkEscape(item.key)}" aria-label="${pkEscape((popover.dataset.cartRemoveLabel || 'Remove') + ' ' + item.product_title)}">
          <svg class="pk-icon pk-icon--trash" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 7h16"></path><path d="M9 7V4h6v3"></path><path d="M7 7l1 14h8l1-14"></path><path d="M10 11v6"></path><path d="M14 11v6"></path></svg>
          <span>${pkEscape(popover.dataset.cartRemoveLabel || 'Remove')}</span>
        </button>
      </div>
      <strong>${pkMoney(item.final_line_price, cart.currency)}</strong>
    </div>`;
  }).join('');
  const more = count > visible.length ? `<div class="pk-cart-mini-more">+ ${count - visible.length} more item${count - visible.length === 1 ? '' : 's'}</div>` : '';
  body.innerHTML = `<div class="pk-cart-mini-items">${rows}${more}</div>`;
}

async function refreshMiniCart(openAfter = false) {
  const popover = document.querySelector('[data-pk-cart-popover]');
  if (!popover) return;
  const url = popover.dataset.cartJsonUrl;
  if (!url) return;
  try {
    const response = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load cart');
    const cart = await response.json();
    renderMiniCart(cart, popover);
    if (openAfter && window.matchMedia('(min-width: 990px)').matches) {
      pkClosePopovers(popover);
      popover.classList.add('is-open');
      popover.querySelectorAll('[data-pk-popover-trigger]').forEach((trigger) => trigger.setAttribute('aria-expanded', 'true'));
    }
  } catch (error) {
    console.warn('[Parklane] Cart refresh failed', error);
  }
}

function initAjaxCartRemoval() {
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cart-remove]');
    if (!button) return;

    const popover = button.closest('[data-pk-cart-popover]');
    if (!popover) return;

    event.preventDefault();
    const key = button.dataset.cartKey;
    const url = popover.dataset.cartChangeUrl;
    if (!key || !url) return;

    const original = button.innerHTML;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      if (!response.ok) throw new Error('Remove from cart failed');
      const cart = await response.json();
      renderMiniCart(cart, popover);
    } catch (error) {
      console.warn('[Parklane] Cart removal failed', error);
      window.location.href = '/cart';
    } finally {
      if (button.isConnected) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.innerHTML = original;
      }
    }
  });
}

function initAjaxAddToCart() {
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.pk-product-card__form');
    if (!form) return;
    event.preventDefault();

    const button = form.querySelector('.pk-add-button');
    const original = button?.innerHTML;
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding…';
    }

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Add to cart failed');
      await response.json();
      await refreshMiniCart(true);
    } catch (error) {
      console.warn('[Parklane] Ajax add failed, falling back to normal cart add', error);
      form.submit();
      return;
    } finally {
      if (button) {
        button.disabled = false;
        button.innerHTML = original;
      }
    }
  });
}

function initProductPageAjaxAdd() {
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.pk-product-page__form');
    if (!form) return;

    event.preventDefault();

    const button = form.querySelector('[data-pk-product-add]');
    if (!button) return;

    const originalText = button.textContent;

    button.disabled = true;
    button.textContent = 'Adding…';

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Add to cart failed');
      }

      await response.json();

      // Updates desktop + mobile cart quantity badge
      await refreshMiniCart(false);

      button.textContent = 'Added ✓';

      window.setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 1200);

    } catch (error) {
      console.warn('[Parklane] Product page add failed', error);

      button.textContent = 'Try again';
      button.disabled = false;

      window.setTimeout(() => {
        button.textContent = originalText;
      }, 1600);
    }
  });
}

function initProductVariantPickers() {
  document.querySelectorAll('[data-pk-product-variant-picker]').forEach((productRoot) => {
    const dataNode = productRoot.querySelector('[data-pk-variant-data]');
    if (!dataNode) return;

    let variants = [];
    try {
      variants = JSON.parse(dataNode.textContent || '[]');
    } catch (error) {
      console.warn('[Parklane] Variant data could not be parsed', error);
      return;
    }
    if (!variants.length) return;

    const groups = [...productRoot.querySelectorAll('[data-pk-option-group]')];
    const variantInput = productRoot.querySelector('[data-pk-variant-id]');
    const price = productRoot.querySelector('[data-pk-product-price]');
    const comparePrice = productRoot.querySelector(
  '[data-pk-product-compare-price]'
);

const discountBadge = productRoot.querySelector(
  '[data-pk-product-discount]'
);
    const image = productRoot.querySelector('[data-pk-product-image]');
    const addButton = productRoot.querySelector('[data-pk-product-add]');
    const currency = productRoot.dataset.currency || 'MVR';

    const selectedValues = () => groups.map((group) => {
      const selected = group.querySelector('.pk-variant-button.is-selected');
      return selected ? selected.dataset.pkOptionValue : '';
    });

    const updateGlobalAvailability = () => {
      groups.forEach((group, optionIndex) => {
        group.querySelectorAll('.pk-variant-button').forEach((button) => {
          const value = button.dataset.pkOptionValue;
          const hasAvailableVariant = variants.some((variant) => variant.available && variant.options?.[optionIndex] === value);
          button.classList.toggle('is-unavailable', !hasAvailableVariant);
        });
      });
    };

    const applyVariant = (variant) => {
      if (!variant) {
        if (variantInput) variantInput.value = '';
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = addButton.dataset.soldOutLabel || 'Unavailable';
        }
        return;
      }

      if (variantInput) variantInput.value = variant.id;

      if (price) price.textContent = pkMoney(variant.price, currency);
      const variantPrice = Number(variant.price || 0);
const compareAtPrice = Number(variant.compare_at_price || 0);

const isOnSale =
  compareAtPrice > 0 &&
  compareAtPrice > variantPrice;

if (comparePrice) {
  if (isOnSale) {
    comparePrice.textContent = pkMoney(
      compareAtPrice,
      currency
    );

    comparePrice.hidden = false;
  } else {
    comparePrice.hidden = true;
  }
}

if (discountBadge) {
  if (isOnSale) {
    const discountPercent = Math.round(
      ((compareAtPrice - variantPrice) /
        compareAtPrice) *
        100
    );

    discountBadge.textContent =
      `${discountPercent}% OFF`;

    discountBadge.hidden = false;
  } else {
    discountBadge.hidden = true;
  }
}

      if (image && variant.media_url) {
        image.src = variant.media_url;
        image.alt = variant.media_alt || image.alt || '';
      }

      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available
          ? (addButton.dataset.addLabel || 'Add to cart')
          : (addButton.dataset.soldOutLabel || 'Sold out');
      }

      if (variant.url && window.history?.replaceState) {
        window.history.replaceState({}, '', variant.url);
      }
    };

    groups.forEach((group) => {
      group.addEventListener('click', (event) => {
        const button = event.target.closest('.pk-variant-button');
        if (!button || !group.contains(button)) return;

        group.querySelectorAll('.pk-variant-button').forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });

        const selections = selectedValues();
        const variant = variants.find((item) => item.options?.every((value, index) => value === selections[index]));
        applyVariant(variant);
      });
    });

    updateGlobalAvailability();
  });
}

function initParklane() {
  document.querySelectorAll('[data-promo-slider]').forEach((slider) => {
    const slides = [...slider.querySelectorAll('.pk-promo__slide')];
    if (slides.length < 2) return;
    let index = 0;
    let timer = null;
    const show = (next) => {
      slides[index].classList.remove('is-active');
      index = (next + slides.length) % slides.length;
      slides[index].classList.add('is-active');
    };
    const autoplay = slider.dataset.autoplay === 'true';
    const interval = Math.max(2000, Number(slider.dataset.interval || 6000));
    const stop = () => { if (timer) window.clearInterval(timer); timer = null; };
    const start = () => { if (autoplay) { stop(); timer = window.setInterval(() => show(index + 1), interval); } };
    slider.querySelector('[data-slider-prev]')?.addEventListener('click', () => { show(index - 1); start(); });
    slider.querySelector('[data-slider-next]')?.addEventListener('click', () => { show(index + 1); start(); });
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    start();
  });

  const drawer = document.querySelector('[data-category-drawer]');
  if (drawer) {
    document.querySelectorAll('[data-category-open]').forEach((button) => {
      button.addEventListener('click', () => {
        drawer.hidden = false;
        requestAnimationFrame(() => drawer.classList.add('is-open'));
        document.body.classList.add('pk-no-scroll');
      });
    });
    drawer.querySelectorAll('[data-category-close]').forEach((button) => {
      button.addEventListener('click', () => {
        drawer.classList.remove('is-open');
        document.body.classList.remove('pk-no-scroll');
        setTimeout(() => { drawer.hidden = true; }, 220);
      });
    });
  }

  initPopovers();
  initAjaxCartRemoval();
initAjaxAddToCart();
initProductPageAjaxAdd();
initProductVariantPickers();
}

document.addEventListener('DOMContentLoaded', initParklane);
document.addEventListener("click", async function (event) {
  const button = event.target.closest("[data-pk-redeem-submit]");

  if (!button) return;

  event.preventDefault();

  const card = button.closest(".pk-points-card");

  const select = card
    ? card.querySelector("[data-pk-redeem-select]")
    : null;

  const status = card
    ? card.querySelector("[data-pk-redeem-status]")
    : null;

  if (!select || button.disabled) return;

  const points = Number(select.value);

  if (!points) return;

  const storageKey = "pkPendingRedemption";
  const originalText = button.textContent;

  let requestId = null;

  try {
    const saved = JSON.parse(
      localStorage.getItem(storageKey) || "null"
    );

    const stillValid =
      saved &&
      saved.points === points &&
      saved.requestId &&
      Date.now() - saved.createdAt < 60 * 60 * 1000;

    if (stillValid) {
      requestId = saved.requestId;
    }
  } catch (error) {
    console.warn("Could not read pending redemption", error);
  }

  if (!requestId) {
    requestId =
      typeof crypto.randomUUID === "function"
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random()
            .toString(36)
            .slice(2)}`;

    try {
      localStorage.setItem(
        storageKey,
        JSON.stringify({
          requestId,
          points,
          createdAt: Date.now()
        })
      );
    } catch (error) {
      console.warn("Could not save redemption request", error);
    }
  }

  button.disabled = true;
  select.disabled = true;
  button.textContent = "Creating reward...";

  if (status) {
    status.textContent = "";
    status.classList.remove("is-error");
  }

  try {
    const response = await fetch(
      "/apps/parklane-points/redeem",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          points,
          requestId
        })
      }
    );

    const data = await response.json();

    if (!response.ok || !data.ok) {
      try {
        localStorage.removeItem(storageKey);
      } catch (error) {}

      throw new Error(
        data.error ||
        data.detail ||
        "Unable to redeem Parklane Points."
      );
    }

    try {
      localStorage.removeItem(storageKey);
    } catch (error) {}

    button.textContent = "Reward created ✓";

    if (status) {
      const rewardValue = points / 100;

      status.textContent =
        `${points.toLocaleString()} points redeemed — MVR ${rewardValue.toFixed(2)} reward applied.`;
    }

    setTimeout(function () {
      window.location.href = data.discountUrl;
    }, 700);

  } catch (error) {
    console.error(
      "Parklane Points redemption:",
      error
    );

    button.disabled = false;
    select.disabled = false;
    button.textContent = originalText;

    if (status) {
      status.textContent = error.message;
      status.classList.add("is-error");
    }
  }
});

function pkOpenMobileAccount() {
  const modal = document.querySelector(
    "[data-pk-mobile-account-modal]"
  );

  if (!modal) return;

  modal.hidden = false;

  document.documentElement.classList.add(
    "pk-mobile-account-open"
  );
}

function pkCloseMobileAccount() {
  const modal = document.querySelector(
    "[data-pk-mobile-account-modal]"
  );

  if (!modal) return;

  modal.hidden = true;

  document.documentElement.classList.remove(
    "pk-mobile-account-open"
  );
}

document.addEventListener("click", function (event) {

  const openButton = event.target.closest(
    "[data-pk-mobile-account-open]"
  );

  if (openButton) {
    event.preventDefault();

    if (typeof pkClosePopovers === "function") {
      pkClosePopovers();
    }

    pkOpenMobileAccount();
    return;
  }

  const closeButton = event.target.closest(
    "[data-pk-mobile-account-close]"
  );

  if (closeButton) {
    event.preventDefault();
    pkCloseMobileAccount();
  }
});

document.addEventListener("keydown", function (event) {
  if (event.key === "Escape") {
    pkCloseMobileAccount();
  }
});

async function pkRefreshRewardStatuses() {
  const items = Array.from(
    document.querySelectorAll(
      "[data-pk-reward-item]"
    )
  );

  if (!items.length) return;

  try {
    const response = await fetch(
      "/apps/parklane-points/history-status",
      {
        method: "GET",
        headers: {
          "Accept": "application/json"
        },
        cache: "no-store"
      }
    );

    const data = await response.json();

    if (!response.ok || !data.ok) {
      throw new Error(
        data.error ||
        "Unable to load reward status."
      );
    }

    const rewards = new Map(
      (data.rewards || []).map((reward) => [
        reward.discountNodeId,
        reward
      ])
    );

    items.forEach((item) => {
      const id = item.dataset.pkRewardId;

      const badge = item.querySelector(
        "[data-pk-reward-status]"
      );

      const applyButton = item.querySelector(
        "[data-pk-reward-apply]"
      );

      const reward = rewards.get(id);

      if (!badge) return;

      badge.classList.remove(
        "is-loading",
        "is-available",
        "is-used",
        "is-unavailable"
      );

      if (
        reward &&
        reward.state === "available"
      ) {
        badge.textContent = "Available";
        badge.classList.add(
          "is-available"
        );

        if (applyButton) {
          applyButton.hidden = false;
        }

        return;
      }

      if (
        reward &&
        reward.state === "used"
      ) {
        badge.textContent = "Used";
        badge.classList.add("is-used");

        if (applyButton) {
          applyButton.hidden = true;
        }

        return;
      }

      badge.textContent = "Unavailable";
      badge.classList.add(
        "is-unavailable"
      );

      if (applyButton) {
        applyButton.hidden = true;
      }
    });

  } catch (error) {
    console.error(
      "Parklane reward status:",
      error
    );

    items.forEach((item) => {
      const badge = item.querySelector(
        "[data-pk-reward-status]"
      );

      if (!badge) return;

      badge.textContent =
        "Status unavailable";

      badge.classList.remove(
        "is-loading"
      );

      badge.classList.add(
        "is-unavailable"
      );
    });
  }
}

if (document.readyState === "loading") {
  document.addEventListener(
    "DOMContentLoaded",
    pkRefreshRewardStatuses
  );
} else {
  pkRefreshRewardStatuses();
}